import { useQuery } from '@tanstack/react-query';
import { fetchLibxProducts } from './apiFetchLibxProducts';
import { ProductFilter } from '../../../../../models/Product';
import { Pagination } from '../../../../../models/Pagination';
import { GlobalReactQueryOptions } from '../../../../config';

const LIBX_PRODUCTS_QUERY = 'libxProducts';
interface PropTypes {
    ageCategory: string;
    genre?: string;
    filterMap: ProductFilter;
    pagination: Pagination;
    enabled?: boolean;
    shopLanguage: string | undefined;
}
export const useLibxProducts = ({
    ageCategory,
    genre,
    filterMap,
    pagination,
    enabled = true,
    shopLanguage
}: PropTypes) => {
    const transformedFilterMap = JSON.stringify(filterMap);

    const { ...data } = useQuery(
        [LIBX_PRODUCTS_QUERY, { ageCategory, genre, filterMap: transformedFilterMap, ...pagination, shopLanguage }],
        () => fetchLibxProducts({ ageCategory, genre, filterMap: transformedFilterMap, pagination, shopLanguage }),
        { ...GlobalReactQueryOptions, enabled }
    );
    const { data: libxProducts } = data;
    return {
        ...data,
        products: {
            count: libxProducts?.totalHits ?? 0,
            list: libxProducts?.hits ?? []
        }
    };
};
